module.exports = __webpack_public_path__ + "static/media/login-background.09d9b1a6.jpg";